const HTTP_ERRORS = {
  404: 'Opa, não conseguimos pegar essa informação.'
}

export default HTTP_ERRORS
